module.exports = __webpack_public_path__ + "img/glossary-suijin1.028c92bd.png";